import { ChevronRight, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { getSafeUrl } from "@/utils/media";
import BrandName from "@/components/BrandName";

const INSTITUTE_LOGO_URL = import.meta.env.VITE_INSTITUTE_LOGO_URL || "/logo-square.png";

export default function CourseCard({ course, onSelect, showBadge = true }) {
  return (
    <Card
      onClick={onSelect}
      className="group flex flex-col border-border overflow-hidden cursor-pointer hover:shadow-lg hover:border-primary/30 transition-all duration-300 transform hover:-translate-y-1"
    >
      {/* Course Image */}
      <div className="w-full aspect-video bg-muted/40 relative overflow-hidden">
        <img
          src={getSafeUrl(course.image)}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            e.currentTarget.src = INSTITUTE_LOGO_URL;
          }}
        />
        {showBadge && (
          <div className="absolute top-4 left-4 bg-card/90 backdrop-blur text-xs font-bold px-3 py-1.5 rounded-full border border-border shadow-sm flex items-center gap-1.5">
            <Award className="w-3.5 h-3.5 text-primary" /> <BrandName /> Certified
          </div>
        )}
      </div>

      {/* Course Info */}
      <CardContent className="p-6 flex flex-col flex-1">
        <h3 className="text-lg font-bold mb-2 text-foreground leading-tight group-hover:text-primary transition-colors line-clamp-2">
          {course.title}
        </h3>
        <p className="text-muted-foreground text-sm line-clamp-2 mb-6 flex-1">
          {course.description}
        </p>

        {/* Pricing and CTA */}
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex flex-col">
            {course.originalPrice && (
              <span className="text-xs text-muted-foreground font-medium line-through">
                {course.originalPrice}
              </span>
            )}
            <span className="text-lg font-extrabold text-foreground">
              {course.discountPrice}
            </span>
          </div>
          <div className="flex items-center gap-1 text-sm font-semibold text-primary">
            View <ChevronRight className="w-4 h-4" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
